/**
 * 面接画面のテーマ表示: いま何のテーマの面接かを患者・課題文・問診票の各画面で示す。
 * DESIGN.md の chip-theme-on（#F4F4F5 × ink, pill, chip 12px/700）を使う。
 */
import { resolveCategoryLabel } from "./InstructionPreviewBody";

const COLORS = {
  ink: "#18181B",
  muted: "#71717A",
  chipOn: "#F4F4F5",
};

export function interviewThemeLabels(
  targetCategories: string[] | undefined,
  categoryLabels?: Record<string, string>,
): string[] {
  const labels = (targetCategories ?? [])
    .filter((categoryId) => categoryId !== "C0")
    .map((categoryId) => resolveCategoryLabel(categoryId, categoryLabels));
  return Array.from(new Set(labels));
}

export function InterviewThemeChip({ labels }: { labels: string[] }) {
  if (labels.length === 0) return null;
  const text = labels.join("・");
  return (
    <span
      title={text}
      style={{
        display: "inline-flex",
        alignItems: "baseline",
        gap: 8,
        maxWidth: "100%",
        padding: "5px 12px",
        borderRadius: 999,
        background: COLORS.chipOn,
        color: COLORS.ink,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: 0.3,
        lineHeight: 1.4,
      }}
    >
      <span style={{ flex: "0 0 auto", color: COLORS.muted, fontSize: 10, fontWeight: 800, letterSpacing: "0.15em" }}>
        テーマ
      </span>
      <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {text}
      </span>
    </span>
  );
}
